export default "__VITE_ASSET__CyULaE$o__"